import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import EmployeeTaxService from '../../services/EmployeeTaxService';
import { showLoader, removeLoader } from "deskera-ui-library";
const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle',
    formData: {
        // liability: [],
        // assets: [],
        // paymentTerm: [],
        // sequenceFormats: []
    }
};
export const fetchEmployeeTAX = createAsyncThunk('employeeTAX', async () => {
    showLoader()
    const response = await EmployeeTaxService.getEmployeeByPage ();
    removeLoader()
    return response;
});
export const EmployeeTaxSlice = createSlice({
    name: 'employeeTAX',
    initialState,
    reducers: {
        addEmployeeTAXColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToEmployeeTAXColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployeeTAX.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchEmployeeTAX.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
    }
});

export const { addEmployeeTAXColumnConfig, addColumnToEmployeeTAXColumnConfig } =
EmployeeTaxSlice.actions;

export const selectEmployeeTAX = (state) => {

    return state.employeeTAX.data
};

export const selectEmployeeTAXColumnConfig = (state) =>
    state.employeeTAX.columnConfig;

export default EmployeeTaxSlice.reducer;